<div [formGroup]="parentGroup" appPreventDoubleClick (throttledClick)="$event.stopPropagation(); openAssignPolicyDialog()">
    <mat-form-field appearance="fill" [ngClass]="{'invisible':formElement.hidden === 'true'}">
        <mat-label>
            {{ formElement.text }}
            <span class="asterisk" *ngIf="formElement.requiredField">*</span>
            <span class="sr-only" *ngIf="isFieldDisabled()">{{ getDisabledReadOnlyAnnouncement() }}</span>
        </mat-label>

        <span matSuffix 
            *ngIf="this.formElement.disabled !== 'true' && isValueSelected()"
            class="clear-icon"
            style="margin-right: 8px;">
          <mat-icon 
            setColor 
            [setColorRules]="[
                {
                    color: 'primaryColour',
                    events: ['hover']
                }
            ]"
            class="material-icons-outlined clickable-icon" 
            appPreventDoubleClick (throttledClick)="$event.stopPropagation(); clearSelectedPosition()">close</mat-icon>
        </span>

        <mat-select disableOptionCentering #positionSelect [formControlName]="formElement.formControl" appPreventDoubleClick (throttledClick)="$event.stopPropagation(); openAssignPolicyDialog()" [attr.aria-disabled]="isFieldDisabled()" [attr.aria-readonly]="readOnly">
              <mat-option></mat-option>

              <ng-container>
                <mat-option *ngFor="let option of positionOptions" [value]="option.id">{{option.name}}</mat-option>
              </ng-container>
        </mat-select>
    </mat-form-field>
</div>
